import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostKakaoAccessToken = () => {
  return useMutation({
    mutationFn: authService.postKakaoAccessToken,
    throwOnError: false,
  });
};
